import React from 'react';
import { useTheme } from 'styled-components';

import { CaretDown } from '~/ui/assets/icons';
import { Popover } from '~/ui/components';

import { get2faScoreColor } from '~/common/utils/clearSale';
import { ClearSaleScoreItem } from '~/typings/entities/person';
import { ScoreWrapper } from './ClearSaleScore.styled';
import { ClearSaleHistory } from './ClearSaleHistory';

export type ClearSaleScoreProps = {
  score: number;
  scoreHistory: ClearSaleScoreItem[];
  showPercent?: boolean;
};

export function ClearSaleScore({ score, scoreHistory, showPercent = true }: ClearSaleScoreProps) {
  const theme = useTheme();
  const formatted = score || score === 0 ? `${score}${showPercent ? '%' : ''}` : '-';
  const color = get2faScoreColor(score);

  if (scoreHistory?.length) {
    return (
      <Popover
        placement="bottomLeft"
        trigger="hover"
        noHeader
        width={330}
        content={<ClearSaleHistory scoreHistory={scoreHistory} />}
      >
        <ScoreWrapper style={{ color }}>
          {formatted} <CaretDown className="action-icon" color={theme.colors.brand.primary} width={12} height={12} />
        </ScoreWrapper>
      </Popover>
    );
  }

  return <span style={{ color }}>{formatted}</span>;
}
